var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBecomeMemberHoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 68,
    viewBox: "0 0 39 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8377_9573)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8377_9573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0381 35.9756C32.5958 35.7717 32.1083 35.785 31.6289 35.9883C31.3042 36.1968 31.1025 36.4837 30.8125 36.9111L30.8076 36.917C30.7504 36.9987 30.6937 37.0808 30.6348 37.165C30.4526 37.4257 30.2725 37.6882 30.0908 37.9521L30.0889 37.9541C29.9074 38.2142 29.7256 38.4743 29.5439 38.7334C29.4222 38.9072 29.3 39.0808 29.1787 39.2549C28.7203 39.9121 28.2528 40.561 27.7822 41.2061V41.207C27.4372 41.6824 27.1048 42.1662 26.7764 42.6582L26.7754 42.6592C25.3128 44.8438 23.5691 46.5585 20.833 47.2129L20.8135 47.2168C18.5867 47.6555 16.3683 47.2372 14.4609 45.9922L14.4414 45.9785C13.2746 45.1349 12.3833 44.1085 11.6084 42.9424C11.3824 42.6071 11.1543 42.274 10.9238 41.9434L10.2236 40.959C9.78631 40.3573 9.35121 39.753 8.92188 39.1436C8.87152 39.0721 8.82142 39.0004 8.76953 38.9268C8.5585 38.627 8.3473 38.3273 8.13672 38.0273C8.02316 37.8656 7.90959 37.7036 7.7959 37.542C7.689 37.39 7.5822 37.2372 7.47559 37.085L7.47656 37.084C7.03743 36.4598 6.85858 36.2122 6.71973 36.0771C6.63372 35.9936 6.58447 35.9674 6.3252 35.877C5.8479 35.8206 5.47997 35.8243 5.14844 35.9756C4.96207 36.1282 4.85056 36.2478 4.77441 36.3682C4.69694 36.4907 4.63916 36.6413 4.5957 36.876C4.5803 37.1291 4.58862 37.3151 4.625 37.4785C4.66185 37.6438 4.73279 37.8102 4.86914 38.0117L4.87012 38.0146C4.96817 38.1615 4.96958 38.1631 5.06738 38.3096C5.1762 38.4685 5.17631 38.469 5.28711 38.6309L5.29004 38.6357C5.36439 38.7467 5.43902 38.8574 5.51562 38.9717C5.72144 39.2787 5.92906 39.585 6.1377 39.8916C6.27904 40.0993 6.4206 40.307 6.56152 40.5146C6.76193 40.8099 6.96255 41.1052 7.16309 41.4004C7.91173 42.5026 8.65921 43.6059 9.4043 44.7109L10.3154 46.0537C12.0442 48.5868 13.5523 51.1341 14.4541 54.1182L14.627 54.7207C14.6508 54.8082 14.6747 54.8961 14.6992 54.9863L14.7012 54.9941C15.2068 56.9886 15.2981 58.9897 15.3574 60.9766C15.3802 61.6839 15.4026 62.3916 15.4258 63.1133H22.7598C22.828 61.0828 22.83 61.0335 22.8525 60.3105V60.3086L22.8945 59.46C23.1545 55.374 24.2777 51.507 26.5361 48.0215L26.7734 47.6631C26.8256 47.5855 26.8779 47.5076 26.9316 47.4277L27.873 46.0469C28.4092 45.2657 28.9398 44.4804 29.4717 43.6934C29.6757 43.3915 29.8799 43.089 30.084 42.7871C30.1354 42.711 30.1873 42.635 30.2402 42.5566C30.5654 42.0756 30.8909 41.5948 31.2168 41.1143L31.8701 40.1494L32.1816 39.6904C32.4139 39.3483 32.6454 39.0066 32.875 38.6641L33.2861 38.0576C33.4564 37.8015 33.5345 37.5954 33.5674 37.3926C33.6004 37.1889 33.5931 36.9593 33.5488 36.6416C33.4603 36.3704 33.3233 36.2074 33.0381 35.9756Z",
    stroke: "#1C1C1E",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.7588 37.5498C20.4933 36.3419 18.5391 36.1126 17.0469 37.0342C16.2141 37.638 15.7029 38.371 15.4365 39.3564C15.3896 39.7624 15.3854 40.1678 15.3916 40.6055V40.6201L15.3867 40.9658C15.3937 42.0613 15.6998 42.9039 16.4395 43.6826C17.2781 44.4796 18.1353 44.7408 19.3242 44.7275C20.3971 44.6842 21.1742 44.2843 21.9395 43.4854C22.546 42.7583 22.7606 41.9985 22.7939 41.0439L22.7979 40.6201V40.6055C22.7994 40.4946 22.8011 40.3836 22.8027 40.2695C22.7975 39.1731 22.4952 38.3286 21.7588 37.5498Z",
    stroke: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8377_9573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2844 19.0517C19.2517 18.982 19.1826 18.9375 19.1057 18.9375C19.0277 18.9375 18.9561 18.9831 18.9239 19.0541C17.7668 21.6064 16.6107 24.1591 15.4736 26.7204C15.2086 27.3175 14.6012 27.6984 14.0326 27.3767C13.9061 27.3055 13.7795 27.2342 13.6491 27.1609C13.5129 27.0831 13.3766 27.0052 13.2362 26.9251C13.0262 26.8065 13.0262 26.8065 12.812 26.6855C12.0749 26.2678 11.3416 25.8441 10.611 25.415C10.4732 25.334 10.3353 25.2531 10.1933 25.1697C9.92856 25.0137 9.66423 24.857 9.40034 24.6996C9.28058 24.6288 9.16082 24.558 9.03743 24.485C8.93257 24.4225 8.82771 24.36 8.71967 24.2956C8.3674 24.1122 8.01282 24.4579 8.11199 24.8424C8.30208 25.5795 8.54196 26.2989 8.78682 27.0248C8.83901 27.181 8.8912 27.3372 8.94497 27.4981C9.13876 28.0775 9.33354 28.6565 9.52821 29.2356C9.64441 29.5821 9.76061 29.9286 9.87707 30.2759C10.4561 32.0024 12.0734 33.1659 13.8944 33.1659C17.341 33.1659 20.7998 33.1659 24.3125 33.1659C26.1338 33.1659 27.7514 32.002 28.3301 30.2752C28.4929 29.7895 28.6568 29.3006 28.8223 28.8068C29.0511 28.1256 29.0511 28.1256 29.2845 27.4306C29.47 26.8759 29.47 26.8759 29.5567 26.6162C29.6173 26.4348 29.6782 26.2535 29.7393 26.0722C29.8317 25.7977 29.9234 25.5229 30.015 25.2481C30.0928 25.0158 30.0928 25.0158 30.1723 24.7788C30.2821 24.4038 29.9129 24.1192 29.5566 24.2798C29.0688 24.4996 28.6172 24.7861 28.1474 25.0671C27.0037 25.7434 25.8537 26.4049 24.6935 27.0521C24.4842 27.1689 24.4842 27.1689 24.2708 27.288C23.7376 27.5851 23.0639 27.3816 22.7954 26.8335C22.2043 25.6273 21.656 24.4047 21.1205 23.1695C20.9246 22.7189 20.7284 22.2685 20.532 21.8182C20.4855 21.7115 20.439 21.6047 20.3911 21.4948C20.0331 20.6752 19.6637 19.8615 19.2844 19.0517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1064 19.3389C17.9747 21.8354 16.8431 24.3308 15.7314 26.835C15.5771 27.1825 15.3177 27.4817 14.9941 27.6455C14.6627 27.8132 14.2694 27.8331 13.8955 27.6221L13.8945 27.623C13.768 27.5519 13.6411 27.4806 13.5107 27.4072L13.5088 27.4062C13.3726 27.3285 13.2361 27.2501 13.0957 27.1699L13.0967 27.1689L12.6729 26.9316C11.9344 26.5131 11.1995 26.0879 10.4678 25.6582L10.0498 25.4131C9.78476 25.2569 9.52011 25.1 9.25586 24.9424L9.25684 24.9414C9.13723 24.8707 9.01679 24.8014 8.89355 24.7285L8.89258 24.7275C8.79182 24.6675 8.69147 24.6067 8.58789 24.5449C8.55228 24.5267 8.52514 24.5254 8.50586 24.5283C8.48461 24.5316 8.46068 24.5429 8.43848 24.5635C8.39349 24.6054 8.36261 24.6813 8.38574 24.7715C8.57291 25.4972 8.80959 26.208 9.05469 26.9346V26.9355C9.10681 27.0916 9.15918 27.2475 9.21289 27.4082C9.40658 27.9873 9.60121 28.5664 9.7959 29.1455C9.91204 29.4918 10.0281 29.8385 10.1445 30.1855V30.1865C10.685 31.7977 12.195 32.8838 13.8945 32.8838H24.3125C26.0123 32.8838 27.5223 31.7972 28.0625 30.1855C28.2253 29.6999 28.3892 29.2105 28.5547 28.7168L29.0166 27.3408C29.202 26.7863 29.2024 26.786 29.2891 26.5264C29.3497 26.345 29.4106 26.1636 29.4717 25.9824C29.5639 25.7084 29.6556 25.4338 29.7471 25.1592V25.1582L29.9023 24.6953C29.9224 24.6223 29.8974 24.577 29.8633 24.5498C29.8247 24.5191 29.7564 24.4995 29.6729 24.5371C29.2042 24.7483 28.7711 25.023 28.292 25.3096L28.291 25.3105C27.1455 25.9879 25.9934 26.6505 24.8311 27.2988C24.6219 27.4155 24.6216 27.4151 24.4082 27.5342V27.5352C23.7368 27.9091 22.8833 27.6543 22.542 26.958C21.9483 25.7463 21.3976 24.5193 20.8613 23.2822C20.6654 22.8318 20.4698 22.381 20.2734 21.9307C20.227 21.824 20.1797 21.7173 20.1318 21.6074C19.7996 20.8468 19.4574 20.0913 19.1064 19.3389Z",
    stroke: "white",
    strokeWidth: 0.564965
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_8377_9573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5782 16.6472C11.7516 16.7124 11.7516 16.9997 11.5782 17.0649C11.0752 17.2542 10.3887 17.5643 9.99011 17.9628C9.59169 18.3613 9.2815 19.0478 9.09231 19.5508C9.02704 19.7243 8.73983 19.7243 8.67457 19.5508C8.48525 19.0478 8.17519 18.3613 7.77664 17.9628C7.37821 17.5643 6.69171 17.2542 6.18866 17.0649C6.01524 16.9997 6.01524 16.7124 6.18866 16.6472C6.69171 16.4579 7.37821 16.1478 7.77664 15.7493C8.17519 15.3508 8.48525 14.6643 8.67457 14.1613C8.73983 13.9879 9.02704 13.9879 9.09231 14.1613C9.2815 14.6643 9.59169 15.3508 9.99011 15.7493C10.3887 16.1478 11.0752 16.4579 11.5782 16.6472Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_8377_9573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9571 16.7175C32.1305 16.7828 32.1305 17.07 31.9571 17.1353C31.4541 17.3245 30.7676 17.6346 30.369 18.0332C29.9706 18.4316 29.6604 19.1181 29.4712 19.6212C29.406 19.7946 29.1187 19.7946 29.0535 19.6212C28.8642 19.1181 28.5541 18.4316 28.1555 18.0332C27.7571 17.6346 27.0706 17.3245 26.5676 17.1353C26.3941 17.07 26.3941 16.7828 26.5676 16.7175C27.0706 16.5282 27.7571 16.2182 28.1555 15.8196C28.5541 15.4211 28.8642 14.7347 29.0535 14.2316C29.1187 14.0582 29.406 14.0582 29.4712 14.2316C29.6604 14.7347 29.9706 15.4211 30.369 15.8196C30.7676 16.2182 31.4541 16.5282 31.9571 16.7175Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_8377_9573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5519 12.4943C23.8384 12.6021 23.8384 13.0768 23.5519 13.1846C22.7208 13.4973 21.5864 14.0097 20.9279 14.6682C20.2695 15.3267 19.757 16.4609 19.4444 17.2921C19.3365 17.5787 18.862 17.5787 18.7541 17.2921C18.4413 16.4609 17.929 15.3267 17.2704 14.6682C16.6121 14.0097 15.4778 13.4973 14.6466 13.1846C14.36 13.0768 14.36 12.6021 14.6466 12.4943C15.4778 12.1816 16.6121 11.6692 17.2704 11.0107C17.929 10.3522 18.4413 9.21797 18.7541 8.38677C18.862 8.10024 19.3365 8.10024 19.4444 8.38677C19.757 9.21797 20.2695 10.3522 20.9279 11.0107C21.5864 11.6692 22.7208 12.1816 23.5519 12.4943Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8377_9573",
    x: 0.000541687,
    y: -0.00282288,
    width: 38.1747,
    height: 68.0139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.04367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17511
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.08735
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.04367
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8377_9573",
    result: "effect2_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8377_9573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8377_9573",
    x: 2.47254,
    y: 31.4051,
    width: 33.2307,
    height: 32.2121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.30765
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807677
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8377_9573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8377_9573",
    x: 6.11833,
    y: 14.1353,
    width: 26.0505,
    height: 19.0288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.82483
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.988689
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8377_9573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_8377_9573",
    x: 1.53887,
    y: 10.1895,
    width: 14.6898,
    height: 18.5296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.25986
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.790951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.51972
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8377_9573",
    result: "effect2_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8377_9573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_8377_9573",
    x: 21.9178,
    y: 10.2598,
    width: 14.6898,
    height: 18.5296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.25986
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.790951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.51972
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8377_9573",
    result: "effect2_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8377_9573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_8377_9573",
    x: 6.96351,
    y: 1.82396,
    width: 24.2722,
    height: 30.6201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.73407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.46813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.73407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8377_9573",
    result: "effect2_dropShadow_8377_9573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8377_9573",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBecomeMemberHoticon);
export default __webpack_public_path__ + "static/media/dashboard-become-member-hoticon.54e56dd3e7a2bd8527ff851cf3c926c0.svg";
export { ForwardRef as ReactComponent };